import type { MissingMandatoryRow } from '@cls/shared';
import { CompSection, EmptyOk } from '../CompSection.js';

interface Props {
  rows: MissingMandatoryRow[];
  onWorker: (id: string) => void;
}

export function MissingCertsSection({ rows, onWorker }: Props) {
  return (
    <CompSection title={`✗ Missing Mandatory Certificates (${rows.length})`} type="danger">
      {rows.length ? (
        <table>
          <thead>
            <tr>
              <th>Worker</th>
              <th>Role</th>
              <th>Missing Certificate</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={`${r.workerId}-${r.certType}-${i}`}>
                <td style={{ cursor: 'pointer' }} onClick={() => onWorker(r.workerId)}>
                  {r.workerName}
                </td>
                <td>{r.roles.join(', ')}</td>
                <td style={{ color: 'var(--danger)', fontWeight: 600 }}>{`✗ ${r.certType}`}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <EmptyOk message="No missing mandatory certificates" />
      )}
    </CompSection>
  );
}
